export default __webpack_public_path__ + "static/media/serv_desarrollo.7d106e94.jpg";